import { Api } from '../api';
import { misc } from '../endpoints';
import { ApprovePasswordRequest, GetContactsResponse, GetDictionariesResponse, GetStatusResponse } from './models';

export class MiscApi extends Api {
  static getContacts = (signal?: AbortSignal) => this.get<GetContactsResponse>({ url: misc.contacts(), signal: signal });

  static getDictionaries = (signal?: AbortSignal) => this.get<GetDictionariesResponse>({ url: misc.dictionaries(), signal: signal });

  static getStatus = (signal?: AbortSignal) => this.get<GetStatusResponse>({ url: misc.status(), signal: signal });

  static approvePassword = (request: ApprovePasswordRequest, signal?: AbortSignal) =>
    this.post<ApprovePasswordRequest, null>({ url: misc.password(), data: request, signal: signal });
}
